import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import { FieldErrors, useForm } from 'react-hook-form';

import { ProfilePicture } from 'components/shared/ProfilePicture/ProfilePicture';
import { FullScreenModalDescription } from 'components/shared/FullScreenModal/FullScreenModalDescription';
import { UploadProfileImageButton } from 'components/shared/UploadProfileImageButton/UploadProfileImageButton';
import { individualProfilePicture } from 'state/individual/individual-state';
import { ICreateWorkerFormData } from 'forms/worker';

interface ICreateWorkerProfilePicture {
    register: ReturnType<typeof useForm>['register'];
    errors: FieldErrors<ICreateWorkerFormData>;
    disabled?: boolean;
    setShowImageModal: (show: boolean) => void;
}

export const CreateWorkerProfilePicture = (({
    register,
    errors,
    disabled,
    setShowImageModal
}: ICreateWorkerProfilePicture) => {
    const {t} = useTranslation();

    const profilePicture = useRecoilValue(individualProfilePicture);

    return (
        <>
            <div className="text-center mb-3">
                <ProfilePicture
                    variant="circle"
                    photo={profilePicture?.base64 || '/assets/images/add-worker-picture.png'}
                    size="large"
                    description={t('createWorker.profilePictureAltText', 'Create worker profile picture')}
                    className="CreateWorker__profile-picture"
                />
            </div>
            <FullScreenModalDescription className="text-center">
                <Trans i18nKey="createWorker.photoDescription">
                    JPEG image at least 400px wide and 400px high, not more than 5 MB in size. Image must be a recent
                    and genuine passport style photograph of you and must closely resemble your photo ID.
                </Trans>
            </FullScreenModalDescription>
            {/*<Form.Group className="form-group--mb-lg">*/}
            <Form.Group controlId="photo">
                <UploadProfileImageButton
                    register={register}
                    errors={errors}
                    profilePicture={profilePicture}
                    disabled={disabled}
                    setShowImageModal={setShowImageModal}
                />
            </Form.Group>
            {/*</Form.Group>*/}
        </>
    );
});
